/* Marelle Announcement Bar - manual carousel + optional autoplay.
   IIFE, no framework. The CSS handles the slide animation; this JS
   only swaps which slide is visible and sets data-dir on the bar
   root to re-trigger the keyframes. Honors prefers-reduced-motion:
   in that case CSS zeroes the keyframes and JS never starts the
   autoplay timer. */

(function () {
  var bar = document.querySelector('[data-marelle-announcement-bar]');
  if (!bar) return;

  var slides = bar.querySelectorAll('[data-slide]');
  if (slides.length < 2) return;

  var prevBtn = bar.querySelector('[data-prev]');
  var nextBtn = bar.querySelector('[data-next]');
  var viewport = bar.querySelector('[data-viewport]');
  if (!prevBtn || !nextBtn || !viewport) return;

  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var current = 0;
  var timer = null;

  function show(idx, dir) {
    if (idx === current) return;
    slides[current].style.display = 'none';
    slides[idx].style.display = '';
    current = idx;
    bar.removeAttribute('data-dir');
    /* force reflow so the keyframe restarts on re-set */
    void viewport.offsetWidth;
    bar.setAttribute('data-dir', dir);
  }

  function goNext() {
    var idx = (current + 1) % slides.length;
    show(idx, 'next');
  }

  function goPrev() {
    var idx = (current - 1 + slides.length) % slides.length;
    show(idx, 'prev');
  }

  prevBtn.addEventListener('click', goPrev);
  nextBtn.addEventListener('click', goNext);

  var autoplayEnabled = bar.dataset.autoplay === 'true';
  var interval = parseInt(bar.dataset.autoplayInterval, 10);
  if (!interval || interval < 1) interval = 5;

  function startAutoplay() {
    if (!autoplayEnabled || prefersReducedMotion) return;
    if (timer) return;
    timer = setInterval(goNext, interval * 1000);
  }

  function stopAutoplay() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  startAutoplay();

  bar.addEventListener('mouseenter', stopAutoplay);
  bar.addEventListener('mouseleave', startAutoplay);
  bar.addEventListener('focusin', stopAutoplay);
  bar.addEventListener('focusout', startAutoplay);
})();
